export function getUmbracoMediaUrl(url?: string) {
  const GRAPHQL_URL = process.env.GRAPHQL_URL?.replace("/graphql", "")

  if (!url || typeof url !== "string") {
    return ""
  }

  if (url.startsWith("/media/")) {
    return GRAPHQL_URL?.endsWith("/")
      ? `${GRAPHQL_URL}${url.substring(1)}`
      : `${GRAPHQL_URL}${url}`
  }

  // Ensure we don't create double slashes when replacing the URL
  const mediaPath = GRAPHQL_URL?.endsWith("/") ? "media/" : "/media/"
  const updatedUrl = url.replace(
    /(https?:\/\/[^\/]+\/media\/)/,
    GRAPHQL_URL + mediaPath,
  )

  return updatedUrl
}
